
import Glide from '@glidejs/glide'
import { ArrowControls, ArrowResizer, BulletsControl } from '../utils/_glide-plugins';

export default class InstructionsSlider {
  ready() {
    const SLIDER_OPTIONS = {
      type: 'carousel',
      startAt: 0,
      perView: 3,
      gap: 32,
      rewind: false,
      bound: true,
      arrowClasses: {
        'back': 'slider-arrow--left',
        'next': 'slider-arrow--right',
        'disabled': 'slider-arrow--disabled'
      },
      bulletWrapper: '.mtt-instructions-slider .slider-bullets',
      bulletClass: '.slider-bullet',
      breakpoints: {
        1000: {
          perView: 2
        },
        700: {
          perView: 1
        }
      }
    }

    if (document.querySelector('.mtt-instructions-slider')) {
      const SLIDER = new Glide('.mtt-instructions-slider .glide', SLIDER_OPTIONS);
      SLIDER.mount({ ArrowControls, ArrowResizer, BulletsControl });
    }
  }
}